export default __webpack_public_path__ + "static/media/Bionic-Arm-08.96bebbed.jpg";